export default {
	wishlistOpen: state => state.wishlistOpen,	
	wishlistProducts: state => state.products,
	cartLoading: state => state.loading,	
};